// Training Providers List

; (function (jQuery) {

	"use strict";

	function Training_Providers_List()
	{

		var global = {
			tp_page_active: 0,
			tp_list_items_display: Number(jQuery('.tp-list').attr('data-display-count'))
		};

		var fn = {

			init: function ()
			{

				// Initialise Pagination Buttons
				fn.TPListPaginateButtons();

				// Filter changes
				jQuery('.tp-filters select').on('change', fn.TPListFilter);

				// Pagination - seperated into keypress and click to improve post-keypress focused element
				jQuery('.pagination--tp')
				.on('keydown', '.pag-button:not(.pag-button--current)', fn.TPListPagination)
				.on('click', '.pag-button:not(.pag-button--current)', fn.TPListPagination);

			},


			// Hide / Show Pagination section. Generate pagination buttons.

			TPListPaginateButtons: function()
			{
				jQuery('.pagination--tp .pagination__list').empty();
				if (jQuery('.pagination--tp .pagination__list').length && typeof global.tp_list_items_display !== 'undefined' && global.tp_list_items_display !== false && jQuery.isNumeric(global.tp_list_items_display))
				{
					// Display pagination buttons if needed
					// Number of 'active' items
					var tp_items_active = jQuery('.tp-list__item--active').length;
					// If pagination needed
					if (tp_items_active > global.tp_list_items_display)
					{
						jQuery('.pagination--tp').show();
						var tp_list_pages_total = Math.ceil(tp_items_active / global.tp_list_items_display);
						// Display buttons
						for (let i = 0; i < tp_list_pages_total; i++)
						{
							jQuery('.pagination--tp .pagination__list').append(`<li class="pag-button pag-button--link" data-tp-pagination-page-num=${i}><a href="#" aria-label="Go to page ${i + 1}">${i + 1}</a></li>`);
						}
						// Set active button
						jQuery('.pagination--tp .pag-button[data-tp-pagination-page-num="' + global.tp_page_active + '"]').addClass('pag-button--current').attr("aria-current", true).attr("aria-label", "Current page");
					}
					else
					{
						jQuery('.pagination--tp').hide();
					}
				}
			},


			// Filter List of Training Providers

			TPListFilter: function(e)
			{
				// Get filter type
				var tpFilterType = jQuery(this).attr('name');

				// Reset other filters
				jQuery('.tp-filters select:not([name=' + tpFilterType + '])').val("All");

				// Filter by selected option
				var tpFilterValue = jQuery(this).val();
					// Display relevant results
				if (tpFilterValue == "All")
				{	// Show all
					jQuery('.tp-list__item').addClass('tp-list__item--active');
				}
				else
				{	// Hide all
					jQuery('.tp-list__item').removeClass('tp-list__item--active');
					// Show matching courses - filter matching values in data attribute
					jQuery('.tp-list__item[data-' + tpFilterType + ']').filter(function()
					{
						// JSON Parse the data attribute
						var tpOptionVals = JSON.parse(jQuery(this).attr('data-' + tpFilterType));
						// Match tax term id
						if (tpOptionVals.includes(tpFilterValue))
						{
							return true;
						}
					})
					// Add Active class to matching items
					.addClass('tp-list__item--active');
				}
				global.tp_page_active = 0;
				fn.TPListPaginateButtons();
				fn.TPListPaginateItems();
			},


			// Pagination - Pagination Button Actions

			TPListPagination(e)
			{
				// If key push then check it's the ENTER key
				if (e.type == "keydown")
				{
					if (e.key === 'Enter' || e.keyCode === 13) {
						// Continue
					}
					else
					{
						// Ignore
						return;
					}
				}
				e.preventDefault();
				// Hide all items in TP list
				jQuery('.tp-list__item').hide();
				// Set active page variable
				global.tp_page_active = Number(jQuery(this).attr('data-tp-pagination-page-num'));
				// Paginate buttons
				fn.TPListPaginateButtons();
				// Paginate Items
				fn.TPListPaginateItems();
				// Put focus on first result item for keyboard navigators
				if (e.type == "keydown")
				{
					jQuery('.tp-list').find('a:visible:first').focus();
				}
				// Scroll back to top
				jQuery('html,body').animate({
					scrollTop: jQuery('.tp-filters').offset().top - 30
				});
			},


			// Paginate List

			TPListPaginateItems()
			{
				jQuery('.tp-list__item').hide();
				if (typeof global.tp_list_items_display !== 'undefined' && global.tp_list_items_display !== false && jQuery.isNumeric(global.tp_list_items_display))
				{
					// Calculate which 'active' list items to show
					var tp_items_active = jQuery('.tp-list__item--active');
					var tp_items_start_pos = global.tp_list_items_display * global.tp_page_active;
					var tp_items_end_pos = tp_items_start_pos + global.tp_list_items_display;
					//console.log(tp_items_start_pos, tp_items_end_pos);
					tp_items_active.slice(tp_items_start_pos, tp_items_end_pos).show();
				}
			}

		}
		jQuery(fn.init);
	}

	new Training_Providers_List();

})(jQuery);